import React from 'react'
import styles from "./PricingSection.module.css";
import { FaCheck } from "react-icons/fa";

function PricingSection() {
    return (
        <section className={styles.pricingSection}>
            <h2>Flexible Pricing for Every Recruitment Need</h2>
            <p>Choose a plan tailored to your hiring volume. Start free or upgrade for unlimited AI <br />
                sourcing, multi-channel outreach, and advanced analytics. ToxBox AI scales with your <br />
                recruitment strategy.</p>
            <div className={styles.pricingGrid}>

                <div className={`${styles.card} ${styles.freeCard}`}>
                    <span className={styles.badgeFree}>Free</span>

                    <h3 className={styles.price}>
                        $0 <span>/ month</span>
                    </h3>

                    <button className={styles.currentBtn}>Current Plan</button>
                </div>

                <div className={`${styles.card} ${styles.premiumCard}`}>
                    <span className={styles.badgePremium}>Premium</span>

                    <div className={styles.checkMark}>
                        <FaCheck size={14} />
                    </div>

                    <h3 className={styles.price}>
                        $0 <span>/ month</span>
                    </h3>

                    <ul className={styles.features}>
                        <li><FaCheck /> Unlimited resume screening</li>
                        <li><FaCheck /> Advanced analytics</li>
                        <li><FaCheck /> Multi-channel integration</li>
                        <li><FaCheck /> Enterprise-grade security</li>
                    </ul>

                    <button className={styles.upgradeBtn}>Upgrade</button>
                </div>
            </div>
        </section>
    )
}

export default PricingSection
